"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixedNum = fixedNum;
exports.numberRound = numberRound;
exports.sizeByWidth = sizeByWidth;
exports.sizeByHeight = sizeByHeight;

function fixedNum(number, fixedto) {
  return parseFloat(number.toFixed(fixedto));
}

function numberRound(action, number, distance) {
  let mathAction;

  switch (action) {
    case 'up':
      mathAction = 'ceil';
      break;

    case 'down':
      mathAction = 'floor';
      break;

    default:
      mathAction = 'round';
      break;
  }

  return Math[mathAction]((number - distance) / distance) * distance + distance;
} // return size by width keep aspect ratio


function sizeByWidth(width, baseWidth, baseHeight) {
  const scale = width / baseWidth;
  return {
    width: baseWidth * scale,
    height: baseHeight * scale
  };
} // return size by height keep aspect ratio


function sizeByHeight(height, baseWidth, baseHeight) {
  const scale = height / baseHeight;
  return {
    width: baseWidth * scale,
    height: baseHeight * scale
  };
}